import { appBaseUrl } from "utils/config";
import { getService } from "../../../commonServices";

export class PriorityListingService {
  getOrganizerEventPriorityListings() {
    let url = `${appBaseUrl}/organizerEvent/organizerEventPriorityListing`;
    let data = getService(url);
    return data;
  }
}